import { render, staticRenderFns } from "./segment-title.vue?vue&type=template&id=7efd33bc&"
import script from "./segment-title.vue?vue&type=script&lang=js&"
export * from "./segment-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports